import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../../component/Loader";

const SupplementaryResponse = () => {
  const navigate = useNavigate();
  const [isRedirecting, setIsRedirecting] = useState(false);

  useEffect(() => {
    setIsRedirecting(true);

    // ePay usually returns params in the hash/query after redirect
    const params = new URLSearchParams(window.location.hash.split("?")[1]);

    const transaction_id = params.get("txnid");
    const examid = params.get("examid");


    // Save only what we need
    localStorage.setItem("transaction_id", transaction_id || "");
    localStorage.setItem("examid", examid || "");
    console.log({transaction_id})
    console.log({examid})




    if (transaction_id && examid) {
      // ✅ valid → redirect to condonation success/summary page
      setTimeout(() => {
        const baseUrl = window.location.origin;
        const newUrl = baseUrl + "/#/supplementaryPayment";
        window.location.href = newUrl;
      }, 1000);
    } else {
      // ❌ invalid response → redirect back to condonation form
      localStorage.setItem("condonation_error", "Payment validation failed");
      const baseUrl = window.location.origin;
      const newUrl = baseUrl + "/#/studentsupplyorbetterment";
      window.location.href = newUrl;
    }
  }, [navigate]);

  return isRedirecting;
};

export default function StudentSupplementaryResponse() {
  const isRedirecting = SupplementaryResponse();

  return isRedirecting ? <Loader /> : null;
}
